module.exports = __webpack_public_path__ + "img/esrr.385ae826.jpg";